export function isFifthElementAndMoreThanFiveSponsors(index: number, numberSponsors: number) {
    return index === 4 && numberSponsors > 4;
}